import React from "react";
import LeaderboardContainer from "../containers/Leaderboard";

const Leaderboard = () => {
  return <LeaderboardContainer />;
};

export default Leaderboard;
